import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './listing-status.scss';
import Tooltip from '../tooltip/tooltip';
import { ArrowBlueDownIcon, ArrowDownIcon } from '../icons/icons';
import AdvancePopover from '../advance-popover/advance-popover';
import DatepickerBox from '../datepicker-box/datepicker-box';
import Dialog from '../dialog/dialog';
import Confirmation from '../confirmation/confirmation';
import { getNumberWithDot } from '../../helpers/utils';

export default function ListingStatus({
  statusLabel,
  enableDropdown,
  futureStatus,
  handleSubmit,
  item,
  autoWidth,
  className,
  icon,
  onlyText,
  label,
  subLabel,
  labelTooltip,
  textClass,
}) {
  const [t] = useTranslation('status');
  const [inputValue, setInputValue] = useState(item?.pendingQty || '');
  const [eventValue, setEventValue] = useState();
  const [date, setDate] = useState(new Date());
  const [qty, setQty] = useState();
  const [isDateSelected, toggleDateSelected] = useState(false);
  const [showPendingOrderDate, setShowPendingOrderDate] = useState(false);
  const [selectedPendingDate, setPendingDate] = useState(new Date());

  useEffect(() => {
    setInputValue(item?.pendingQty || '');
    setQty(item?.pendingQty || '');
  }, [item?.pendingQty]);

  const handleCancelClick = () => {
    setShowPendingOrderDate(true);
  };

  const handleCargoReadySubmit = () => {
    console.log('Cargo ready date submitted');
  };

  const setCargoReadyDate = () => {
    console.log('Successful');
  };

  const togglePopover = (e) => {
    setEventValue(e?.target);
  };

  const handleClose = () => {
    setEventValue(null);
  };

  const handleStatus = (e) => {
    handleSubmit({
      statusName: e.stageName,
      statusDate: date,
      Qty: Number(qty),
    });
  };

  const handleUpdate = (e) => {
    handleStatus(e);
    handleClose();
  };

  return !enableDropdown ? (
    <>
      {onlyText && (
        <span
          className={`status ${
            statusLabel?.toLowerCase() === 'booked' ? 'new' : ''
          } ${statusLabel
            ?.toLowerCase()
            .replace(/\s/g, '-')
            .replace(/&/g, '-')
            .replace('.', '-')}${
            statusLabel?.toLowerCase() === 'approved' ? 'accepted' : ''
          } ${autoWidth ? 'w-auto' : ''} ${className}${
            onlyText ? ' text-wrap ' : ''
          }`}
        >
          <span className={`txt ${textClass} ${autoWidth ? 'w-m-auto' : ''}`}>
            {label?.toLowerCase()}
          </span>
          <span className="sub-text">{subLabel?.toLowerCase()}</span>
        </span>
      )}
      {!onlyText && (
        <Tooltip
          className="justify-center"
          content={
            labelTooltip ||
            t(`statuslist.substatus.${statusLabel?.toLowerCase()}`)
          }
        >
          <span
            className={`status ${
              statusLabel?.toLowerCase() === 'booked' ? 'new' : ''
            } ${statusLabel
              ?.toLowerCase()
              .replace(/\s/g, '-')
              .replace(/&/g, '-')
              .replace(/\./g, '')}${
              statusLabel?.toLowerCase() === 'approved' ? 'accepted' : ''
            } ${autoWidth ? 'w-auto' : ''} ${className}${
              onlyText ? ' text-wrap ' : ''
            }`}
          >
            <span className={`txt ${textClass}`}>
              {statusLabel &&
                t(`statuslist.substatus.${statusLabel?.toLowerCase()}`)}
            </span>
          </span>
        </Tooltip>
      )}
    </>
  ) : (
    <>
      <Tooltip
        content={t(`statuslist.substatus.${statusLabel?.toLowerCase()}`)}
      >
        <button
          type="button"
          className={`status changable ${
            statusLabel?.toLowerCase() === 'booked' ? 'new' : ''
          }${
            statusLabel?.toLowerCase() === 'approved' ? 'accepted' : ''
          }${statusLabel?.toLowerCase().replace(/\s/g, '-')} ${
            autoWidth ? 'w-auto' : ''
          }`}
          onClick={togglePopover}
          id="statusPopover"
        >
          <span className="txt">
            {statusLabel &&
              t(`statuslist.substatus.${statusLabel?.toLowerCase()}`)}
          </span>

          <ArrowDownIcon />
        </button>
      </Tooltip>
      <AdvancePopover
        reference="statusPopover"
        getEvent={eventValue}
        closePopover={handleClose}
        placement="self-bottom"
      >
        <div className="change-status-container md">
          <ArrowBlueDownIcon />
          {futureStatus?.length > 0 &&
            futureStatus?.map((sts) => (
              <>
                {sts.QtySplit && (
                  <div className="quantity-box">
                    <label htmlFor="">{t('dropdown.quantity')}</label>
                    <input
                      placeholder={t('dropdown.quantityplaceholder')}
                      value={inputValue}
                      onKeyDown={(e) => {
                        getNumberWithDot({ e, decimalLimit: 3 });
                      }}
                      onChange={(e) => {
                        setInputValue(e.target.value);
                        setQty(e.target.value);
                      }}
                      onPaste={(e) => {
                        e.preventDefault(); // Prevent the default paste action
                        const pastedValue = e.clipboardData.getData('text');
                        if (/^\d*\.?\d*$/.test(pastedValue)) {
                          const [integerPart, decimalPart] =
                            pastedValue.split('.');
                          const sanitizedValue = decimalPart
                            ? `${integerPart}.${decimalPart.slice(0, 3)}`
                            : integerPart;
                          e.target.value = sanitizedValue; // Set sanitized value
                          e.target.dispatchEvent(
                            new Event('input', { bubbles: true })
                          ); // Trigger React change
                        }
                        setInputValue(e.target.value);
                        setQty(e.target.value);
                      }}
                    />
                  </div>
                )}
                {false && (
                  <span className="date-picker align-center">
                    {t('dropdown.date')}

                    <input
                      type="text"
                      value={date ? date.toLocaleDateString('en-GB') : ''}
                    />

                    {icon && (
                      <>
                        <button
                          type="button"
                          id="showDateBox"
                          onClick={togglePopover}
                          className="icon-button w-auto"
                        >
                          {icon}
                        </button>
                        <AdvancePopover
                          reference="showDateBox"
                          closePopover={handleClose}
                          getEvent={eventValue}
                          placement="left"
                          zIndex={10000002}
                        >
                          <div className="datepicker-header">
                            <label>
                              {t('statuslist.cargoradydate.selectcargodate')}
                            </label>
                          </div>
                          <div className="cargo-datepickers">
                            <div className="datepicker-container">
                              <DatepickerBox
                                inline
                                onChange={(e) => {
                                  if (e <= new Date()) {
                                    setDate(e);
                                  }
                                }}
                                // disableIcon
                                // enableEdit
                              />
                            </div>
                            gftyfguybuhguibhiu
                            <div className="datepicker-footer d-flex">
                              <button type="button" className="button cancel">
                                {t('statuslist.cargoradydate.cancel')}
                              </button>
                              <button
                                type="submit"
                                className="button action primary"
                                onClick={toggleDateSelected}
                              >
                                {date
                                  ? `${t(
                                      'statuslist.cargoradydate.select'
                                    )} ${date.toLocaleDateString()}`
                                  : t('statuslist.cargoradydate.selectdate')}
                              </button>
                            </div>
                          </div>
                        </AdvancePopover>
                      </>
                    )}
                  </span>
                )}

                <span className="date-picker">
                  {t('dropdown.date')}
                  <DatepickerBox
                    selectedDate={date}
                    onChange={(e) => {
                      if (e <= new Date()) {
                        setDate(e);
                      }
                    }}
                    placeholder={t('dropdown.dateplaceholder')}
                    // enableEdit
                  />
                  {/* <EditCalenderIcon /> */}
                </span>

                <button
                  type="button"
                  className={`button-submit ${sts.stageName
                    ?.toLowerCase()
                    .replace(/\s/g, '-')}`}
                  onClick={() => {
                    handleUpdate(sts);
                  }}
                  disabled={
                    qty <= 0 || qty > item.pendingQty || date > new Date()
                  }
                >
                  {t(`statuslist.updatestatus.${sts.stageName}`)}
                </button>
              </>
            ))}
        </div>
      </AdvancePopover>
      <Dialog
        isShowing={isDateSelected}
        hide={toggleDateSelected}
        placement="center"
        maskZindex={10000004}
      >
        {!showPendingOrderDate ? (
          <Confirmation
            cancelButtonText={t('statuslist.cargoradydate.no')}
            submitButtonText={t('statuslist.cargoradydate.yes')}
            title={t('statuslist.cargoradydate.cargoreadydate')}
            description={t('statuslist.cargoradydate.confirmationmsg')}
            onSubmitClick={setCargoReadyDate}
            onCancelClick={handleCancelClick}
          />
        ) : (
          <div className="d-flex align-center">
            <Confirmation
              cancelButtonText={t('statuslist.cargoradydate.enterlater')}
              submitButtonText={t('statuslist.cargoradydate.enter')}
              title={t('statuslist.cargoradydate.cargoreadydate')}
              description={t('statuslist.cargoradydate.pendingconfirmation')}
              onSubmitClick={handleCargoReadySubmit}
              onCancelClick={() => setShowPendingOrderDate(false)}
              btnColor="enter-later"
            >
              <DatepickerBox
                onChange={(e) => {
                  if (e <= new Date()) {
                    setPendingDate(e);
                  }
                }}
                selectedDate={selectedPendingDate}
                mTop="1.389vw"
                enableEdit
              />
            </Confirmation>
          </div>
        )}
      </Dialog>
    </>
  );
}
ListingStatus.propTypes = {
  statusLabel: PropTypes.string,
  enableDropdown: PropTypes.bool,
  futureStatus: PropTypes.instanceOf(Array),
  handleSubmit: PropTypes.func,
  item: PropTypes.instanceOf(Object),
  autoWidth: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.element,
  onlyText: PropTypes.bool,
  label: PropTypes.string,
  labelTooltip: PropTypes.string,
  subLabel: PropTypes.string,
  textClass: PropTypes.string,
};
ListingStatus.defaultProps = {
  statusLabel: '',
  enableDropdown: false,
  futureStatus: [],
  handleSubmit: () => {},
  item: {},
  autoWidth: false,
  className: '',
  icon: {},
  onlyText: false,
  label: '',
  labelTooltip: '',
  subLabel: '',
  textClass: '',
};
